export const columnWidthConstants = {
    ACTION_COLUMN_WIDTH: 135,
    ISSUES_COLUMN_WIDTH: 250,
    STANDARD_COLUMN_WIDTH: 150,
    WIDE_COLUMN_WIDTH: 300,
}

export const NO_RESULTS_EXPLANATION = (
    "Nothing to see here! You need to add some data to see results from this search, " +
    "or you might try changing your region."
)

export const dataTypesWithoutRowLinks = [
    DjangIO.app.models.QuorumDataType.alert.value,
    DjangIO.app.models.QuorumDataType.attachment.value,
    DjangIO.app.models.QuorumDataType.grassroots_action.value,
    DjangIO.app.models.QuorumDataType.note.value,
    DjangIO.app.models.QuorumDataType.send_email.value,
    DjangIO.app.models.QuorumDataType.receipt.value,
    DjangIO.app.models.QuorumDataType.disbursement.value,
]

export const dataTypesWithoutColumnSorting = [
    DjangIO.app.models.QuorumDataType.alert.value,
    DjangIO.app.models.QuorumDataType.document.value,
    DjangIO.app.models.QuorumDataType.media.value,
]

export const feedItemDataTypesWithPriority = [
    DjangIO.app.models.QuorumDataType.amendment.value,
    DjangIO.app.models.QuorumDataType.bill.value,
    DjangIO.app.models.QuorumDataType.docket.value,
    DjangIO.app.models.QuorumDataType.media.value,
    DjangIO.app.models.QuorumDataType.person.value,
    DjangIO.app.models.QuorumDataType.regulation.value,
    DjangIO.app.models.QuorumDataType.staffer.value,
    DjangIO.app.models.QuorumDataType.supporter.value,
]

export const feedItemDataTypesWithStance = [
    DjangIO.app.models.QuorumDataType.amendment.value,
    DjangIO.app.models.QuorumDataType.bill.value,
    DjangIO.app.models.QuorumDataType.docket.value,
    DjangIO.app.models.QuorumDataType.document.value,
    DjangIO.app.models.QuorumDataType.media.value,
    DjangIO.app.models.QuorumDataType.regulation.value,
    DjangIO.app.models.QuorumDataType.vote.value,
]

export const feedItemDataTypesWithAlignment = [
    DjangIO.app.models.QuorumDataType.person.value,
    DjangIO.app.models.QuorumDataType.staffer.value,
    DjangIO.app.models.QuorumDataType.supporter.value,
]
